exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".records-content[data-v-21aa2114] {\n  padding: 20px;\n}\n.title[data-v-21aa2114] {\n  font-size: 22px;\n}\n", ""]);

// exports
